export default {
  getLocalStorage(sKey, version, callback) {
    let result;
    // sKey = 'hot_product_' + sKey;
    // sKey = 'hot_product';
    let projectKey = 'holdconf';
    if (window.__ths_localstorage && window.__ths_localstorage[sKey] && window.__ths_localstorage[sKey].v === version) {
      if (callback) {
        callback(window.__ths_localstorage[sKey].value);
      }
      return window.__ths_localstorage[sKey].value;
    }
    try {
      result = localStorage.getItem(projectKey);
      result = JSON.parse(result);
      window.__ths_localstorage = result;
      if (result && result[sKey] && result[sKey].v === version) {
        if (callback) {
          callback(result[sKey].value);
        }
        return result[sKey].value;
      }
    } catch (e) {
      console.error(e);
    }
  },
  setLocalStorage(sKey, item, version = 'v1.0') {
    // sKey = 'hot_product_' + sKey;
    let projectKey = 'holdconf';
    //为了防止对象被修改
    let value = JSON.parse(JSON.stringify(item));
    if (window.__ths_localstorage) {
      window.__ths_localstorage[sKey] = { v: version, value: value };
    } else {
      window.__ths_localstorage = {};
      window.__ths_localstorage[sKey] = { v: version, value: value };
    }
    try {
      localStorage.setItem(projectKey, JSON.stringify(window.__ths_localstorage));
    } catch (e) {
      console.error(e);
      localStorage.clear();
    }
  },
  // getLocalStorage(sKey, callback) {
  //   let result;
  //   try {
  //     result = localStorage.getItem(sKey);
  //     result = JSON.parse(result);
  //     if (result && callback) {
  //       callback(result);
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   }
  //   return JSON.parse(JSON.stringify(result));
  // },
  // setLocalStorage(sKey, item) {
  //   try {
  //     localStorage.setItem(sKey, JSON.stringify(item));
  //   } catch (e) {
  //     localStorage.clear();
  //   }
  // },
  getDataType(url) {
    return url.indexOf(location.host) > -1 ? 'json' : 'jsonp';
  }
};



// WEBPACK FOOTER //
// ./src/utils/project.js